const payroll = {
  payroll: "الرواتب",
  byEvent: {
    name: "المعرف",
    event: "الأحداث",
    projectManager: "مديرو المشاريع",
    type: "النوع",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    publishingMode: "وضع النشر",
    approved: "الموافقة",
  },
  listPayroll: {
    eventType: "نوع الحدث",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    projectManagers: "مديرو المشاريع",
    publishingMode: "وضع النشر",
    noDataDescription: "عذرًا، لم يتم العثور على أحداث.",
    publishMode: "وضع النشر",
    searchPlaceHolder: "البحث عن الأحداث",
    daily: "يوميًا",
    monthly: "شهريًا",
    eventTabs: {
      ongoing: "جارية",
      upcoming: "القادمة",
      previous: "مكتملة",
      pending: "قيد الانتظار",
      cancelled: "ملغاة",
    },
    eventStatus: {
      ongoing: "جارية",
      upcoming: "القادمة",
      past: "مكتملة",
      pending: "قيد الانتظار",
      canceled: "ملغاة",
    },
    generatePayrollAllUser: "إنشاء كشف الرواتب لجميع المستخدمين",
  },
  payrollApplicants: {
    payrollApplicantList: "قائمة المتقدمين للرواتب",
    applicant: "المتقدمين",
    id: "المعرف",
    image: "صورة",
    name: "اسم المتقدم",
    email: "البريد الإلكتروني",
    role: "الدور",
    note: "ملاحظة",
    days: "الأيام",
    payrollDays: "أيام الرواتب",
    nationality: "الجنسية",
    city: "المدينة",
    age: "العمر",
    gender: "الجنس",
    payrollAction: "إجراء الرواتب",
    action: "الإجراءات",
    generatePayroll: "إنشاء الرواتب",
    autoDeduction: "الخصم التلقائي",
    manualDeduction: "الخصم اليدوي",
    giveReward: "منح مكافأة",
    manualDeductionReason: "سبب الخصم اليدوي",
    manualDeductionAmount: "مبلغ الخصم اليدوي",
    signature: "التوقيع",
    rewardReason: "سبب المكافأة",
    reward: "مكافأة",
    removedApplicants: "المتقدمين المُزَالين",
    stcNumber: "رقم STC pay",
    iqamaId: "رقم الإقامة",
    nationalId: "رقم الهوية",
    noDataDescription: "عذرًا، لم يتم العثور على بيانات الرواتب",
    rangeTemplate: "عرض {from}-{to} من {total} متقدم",
    on: "تشغيل",
    off: "إيقاف",
    transferTax: "ضريبة التحويل",
    transferCommission: "عمولة التحويل",
    training: "تدريب",
    numberOfTrainingDays: "عدد أيام التدريب",
    trainingPayPerDay: "راتب التدريب في اليوم",
    totalTrainingPay: "إجمالي راتب التدريب",
    labels: {
      generatePayroll: "إنشاء الرواتب",
      payrollAmount: "مبلغ الرواتب",
      deductionAmount: "مبلغ الخصم",
      deductionReason: "سبب الخصم",
      rewardAmount: "مبلغ المكافأة",
      rewardReason: "سبب المكافأة",
      totalAmount: "المبلغ الإجمالي",
      amount: "المبلغ",
      reason: "السبب",
      actions: {
        exportXl: "تصدير xlxs",
        revertDeduction: "الغاء الخصم",
        revertReward: "الغاء المكافأة",
      },
    },
    placeholder: {
      enterAmount: "أدخل المبلغ",
      enterReason: "أدخل السبب",
    },
    titleModals: {
      areYouSure: "هل أنت متأكد أنك تريد تطبيق الخصم التلقائي؟",
      areYouSureAutoDeduction:
        "هل أنت متأكد أنك تريد تطبيق الخصم التلقائي على جميع المستخدمين؟",
      areYouSureRevertReward: "هل أنت متأكد من رغبتك في إرجاع المكافأة؟",
      areYouSureRevertDeduction: "هل أنت متأكد من رغبتك في إرجاع الخصم؟",
      manualDeduction: "الخصم اليدوي",
      giveReward: "منح مكافأة",
    },
    exportsHeading: {
      eventName: "اسم الفعالية",
      date: "التاريخ",
      name: "الاسم",
      id: "المعرف",
      day: "اليوم",
      payrollDay: "الراتب/اليوم",
      autoDeduction: "الخصم التلقائي",
      manualDeduction: "الخصم اليدوي",
      reward: "المكافأة",
      manualDeductionReason: "سبب الخصم اليدوي",
      rewardReason: "سبب المكافأة",
      totalAmount: "المبلغ الإجمالي",
      stcNumber: "رقم STC pay",
      projectManger: "مدير المشروع",
      location: "الموقع",
      training: "التدريب",
      numberOfTrainingDays: "عدد أيام التدريب",
      trainingPayPerDay: "راتب التدريب في اليوم",
      totalTrainingPay: "إجمالي راتب التدريب",
      transferTax: "ضريبة التحويل",
      transferCommission: "عمولة التحويل",
    },
    selectAll: "تحديد الكل",
    exportPayroll: "تصدير الرواتب",
    exportPayrollSubtitle: "اختر الحقول التي تريد تضمينها في ملف Excel",
    errorMsg: "أدخل سببًا آخر لا يتجاوز 20 حرفًا!",
  },
};

export default payroll;
